module.exports = __webpack_public_path__ + "img/section22.079d710b.png";